import Cookies from 'universal-cookie';
import { parse } from '@wkda/cid-parser';
export function getCIDCookie(req) {
  var _req$headers;
  const cookies = new Cookies(req === null || req === void 0 || (_req$headers = req.headers) === null || _req$headers === void 0 ? void 0 : _req$headers.cookie);
  return parse(cookies.get('WKDA'));
}